import { createContext, useContext } from 'react';

export type OrgRow = {
  id: string;
  name: string;
  slug: string | null;
};

export type OrgUser = {
  id: string;
  email: string;
  full_name: string | null;
  role: 'owner' | 'admin' | 'agent' | 'viewer';
  org_id: string | null;
  canEdit: boolean;
};

export type OrgContextValue = {
  loading: boolean;
  org: OrgRow | null;
  orgId: string | null;
  currentUser: OrgUser | null;
  refresh: () => Promise<void>;
};

const defaultValue: OrgContextValue = {
  loading: true,
  org: null,
  orgId: null,
  currentUser: null,
  refresh: async () => undefined,
};

export const OrgContext = createContext<OrgContextValue>(defaultValue);

export const useOrgContext = () => useContext(OrgContext);



